import React, {useEffect, useMemo, useState} from 'react';
import { Form, Input, DatePicker, InputNumber } from 'antd';
import SPSelectWithApi from "../../../../../../components/product-price/base/SPSelectWithApi";
import OrderDeductionModal from "../index";
import SPSelectWithEnum from "../../../../../../components/product-price/base/SPSelectWithEnum";
import SPUploadPhotos from "../../../../../../components/base/SPUploadPhotos";
import {API_VEHICLE_UPLOAD_PHOTO} from "../../../../../../hooks/carRental/_";
import SPDynamicFormRender from "../../../../../../components/base/SPDynamicFormRender";
import OrderRefundModal from "../index";
import EnumKeyToText from "../../../../base/CostInfo/enumkeyTotext";
import {validateTwoDecimalPlaces} from "../../../../../../utils/tool";
const { TextArea } = Input;

// const OccupationOrderView = [
//     {
//         xtype: 'grid', xprops: { colums: '1' }, children:
//             [
//                 { name: 'deduct_type', xtype: 'enumSelect',
//                     rules: [{ message: '请选择退款原因' }],
//                     xprops: {
//                         enumKey: 'deposit_deduct_type',
//                         placeholder: '请选择退款原因',
//                         allowClear: true,
//                         disabled: true,
//                         label: '退款原因' }
//                 },
//                 {
//                     xprops: {
//                         label: '退款金额',
//                         placeholder: '请输入退款金额',
//                         max: 100,
//                         step: 0.01,
//                         prefix: '￥',
//                         addonAfter: '可操作金额： 5000￥'
//
//                     },
//                     name: 'amount',
//                     xtype: "inputNumber",
//                     rules: [{required: true, message: '请输入退款金额'}]
//                 },
//                 {
//                     name: 'reason',
//                     xtype: 'TextArea',
//                     rules: [{
//                         required: true,
//                         message: '请输入退款说明'
//                     }],
//                     xprops: {
//                         placeholder: '请输入退款说明',
//                         label: '退款说明',
//                         rows: 2,
//                         maxLength: 30
//                     }
//                 },
//
//                 { name: 'evidence',
//                     xtype: 'SPUploadPhotos',
//                     rules: [{ required: false, message: '请上传退款凭证' }],
//                     xprops: {
//                         label: '退款凭证',
//                         action: API_VEHICLE_UPLOAD_PHOTO,
//                         name: 'order_refund_evidence',
//                         maxNum:6,
//                         fileSize:10,
//                         hideTitle: true
//                     }
//                 },
//
//             ]
//     }
// ]


interface IComponentProps {
  data?: any;
    enums?: any
}
const RefundOfDepositDeduction: React.FC<IComponentProps> = (props) => {
  const data = props.data;
  const { enums } = props

    const mainFormFields = {
        cheliangwaiguantupian: {
            name: ''
        }
    }
    const settle_amount = useMemo(() => {
        return data?.remain_amount / 100
    }, [data]);

    return (
    <>
        {/*<SPDynamicFormRender data={OccupationOrderView} enums={enums} echoData={{}}></SPDynamicFormRender>*/}
    <Form.Item label={'退款原因'}>
        <EnumKeyToText data={data} enums={enums} valueKey={'deduct_type'} nameSpace={'deduct_refund_type'} />
        {/*<SPSelectWithEnum*/}
        {/*    disabled*/}
        {/*    placeholder={'请选择退款原因'}*/}
        {/*    enums={enums}*/}
        {/*    enumKey={'deposit_deduct_type'}>*/}
        {/*</SPSelectWithEnum>*/}
    </Form.Item>
    <Form.Item name={'amount'} label={'退款金额'} rules={[
        {required: true, message: '请选择退款金额'},
        { validator: validateTwoDecimalPlaces },
        {
            type: 'number',min: 0.01, max: settle_amount, message: `请输入1-${settle_amount}的正整数`
        }
    ]}>
        <InputNumber max={settle_amount || Number.MAX_VALUE} step={1} prefix="￥" style={{ width: '100%' }} addonAfter={`可操作金额： ${settle_amount}元`}/>
    </Form.Item>
        <Form.Item name={'reason'} label={'退款说明'} rules={[{required: false, message: '请输入退款说明'}]}>
            <TextArea rows={4} showCount placeholder="请输入退款说明" maxLength={30} />
        </Form.Item>
        <Form.Item name={'evidence'} label={'退款凭证'} >
            <SPUploadPhotos
                action={API_VEHICLE_UPLOAD_PHOTO}
                maxNum={6}
                fileSize={10}
                hideTitle
            />
        </Form.Item>
    </>

  );
};

export default RefundOfDepositDeduction;
